"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var vue_1 = require("vue");
var reactivity_1 = require("@vue/reactivity");
var jquery_1 = __importDefault(require("jquery"));
exports["default"] = (0, vue_1.defineComponent)({
    props: {
        fakeer: Object,
        removeElementButton: Boolean,
        addElement: Function
    },
    setup: function (__props, _a) {
        var expose = _a.expose;
        expose();
        var props = __props;
        window.$ = window.jQuery = jquery_1["default"];
        var elementId = Date.now();
        var institutions = (0, reactivity_1.computed)(function () {
            return window.institutions;
        });
        var specialitys = (0, reactivity_1.computed)(function () {
            return window.specialitys;
        });
        var specialityArray = (0, reactivity_1.computed)(function () {
            return window.specialityArray;
        });
        function removeElement() {
            /**
             * @type {HTMLDivElement}
             */
            var element = document.getElementById('form' + elementId);
            element.parentNode.removeChild(element);
        }
        /**
         * @param {Event} event
         */
        function workInstitutionChange(event) {
            var element_value = $(event.currentTarget).val();
            if (element_value) {
                if (element_value == "other_wa_institution_option") {
                    $(event.currentTarget)
                        .closest(".row")
                        .find(".other_wa_institution_div")
                        .show();
                }
                else {
                    $(event.currentTarget)
                        .closest(".row")
                        .find(".other_wa_institution_div")
                        .hide();
                }
            }
        }
        /**
         * @param {Event} event
         */
        function checkSpecialityChange(event) {
            var element_value = $(event.currentTarget).val();
            if (element_value) {
                if (element_value == "other_speciality_option") {
                    $(event.currentTarget)
                        .parents(".pg-traning-fields")
                        .find(".other_speciality_div")
                        .show();
                }
                else {
                    $(event.currentTarget)
                        .parents(".pg-traning-fields")
                        .find(".other_speciality_div")
                        .hide();
                }
            }
        }
        var __returned__ = { props: props, elementId: elementId, institutions: institutions, specialitys: specialitys, specialityArray: specialityArray, removeElement: removeElement, workInstitutionChange: workInstitutionChange, checkSpecialityChange: checkSpecialityChange, computed: reactivity_1.computed, jquery: jquery_1["default"] };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
